export const DEFAULT_LOCALE = 'el';
